import axios from 'axios';
import { API_RESULT_CD, CommonResult, createApiRequestUrl, OK } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const URL = createApiRequestUrl('master/itemImage');

export interface ItemImageInfo {
  itemCode: string;
  carrierId: number;
  mobileCategory: string;
  mobileCategoryDetail: string;
  effectiveDateFrom: string;
  effectiveDateTo: string;
  modelCode: string;
  modelLongName: string;
  imageUrl: string;
}
export interface MasterItemImageApiResponse {
  itemImageList: Array<ItemImageInfo>;
  result: CommonResult;
}

export interface MasterItemImageApiResponseErrorResponse {
  itemImageList: Array<ItemImageInfo>;
  result: CommonResult;
}

export async function masterItemImageApiGet(): Promise<MasterItemImageApiResponse> {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.get<MasterItemImageApiResponse>(URL, {
      headers,
    });
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      default:
        throw response;
    }
  } catch (error) {
    // TODO: エラーハンドリング実装後
    return {
      itemImageList: [],
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: API_RESULT_CD.ERROR,
            resultMessage: `${API_EXCEPTION_MSG}  エラー内容:[${error}]`,
          },
        ],
      },
    };
  }
}
